<style lang="less" rel="stylesheet/less" type="text/less">

    .customer-material-2D-index {
        .el-table th>.cell , .el-table .cell {
            text-align: center;
        }
    }

</style>

<template>

    <div class="customer-material-2D-index" >

        <el-table align="center" :data="materials" style="width:100%"  border  v-loading="loading" @sort-change="sortable">

            <el-table-column prop="name"  label="素材名称" ></el-table-column>

            <el-table-column prop="uuid"  label="素材编码" ></el-table-column>

            <el-table-column prop="frame_img"  label="镜框" >
                <template slot-scope="scope">
                    <img :src="scope.row.frame_img" alt="" style="width: 50%;height: 50%;">
                </template>
            </el-table-column>

             <el-table-column prop="temple_img"  label="镜腿" >
                <template slot-scope="scope">
                    <img :src="scope.row.temple_img" alt="" style="width: 50%;height: 50%;">
                </template>
            </el-table-column>

            <el-table-column prop="created_at"  label="创建时间" sortable="custom" ></el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>

    </el-table>

    </div>

</template>

<script>

export default {

    name: 'admin-material-2D-index',

    props: ['materials','loading'],

    data: function() {

        return {
			token:''

        }

    },
	 created() {
		this.token = sessionStorage.getItem("token");
	  },

    methods: {

        /**
         * 2D素材删除
         * @param  {Object} record {传入的对象}
         * @return {undefined}
         */
        handleDelete(record) {

            this.$emit('delete',record.id);
        },

        /**
         * 2D素材编辑
         * @param  {Object} record {传入的对象}
         * @return {undefined}
         */
        handleEdit(record) {

            this.$emit('edit',record);
        },

        		/**
         * 排序的回调
         * @param  {Object} param {对应列的属性对象,里面包含了column列属性，key值，order排序字段}
         * @return {undefined}
         */
		sortable(param) {
			const search_param = {
				sort_column:param.order==='normal'?'': param.prop,

                sort_by: param.order === 'normal' ? '' : param.order,


            };
            if (search_param.sort_by=='ascending') {
                search_param.sort_by='ASC'

            }
            if (search_param.sort_by=='descending') {
                search_param.sort_by='DESC'
            }
            // search_param.sort_by.toLocaleUpperCase()
            // console.log('排序数据',param)
			this.$emit('sort', search_param);
		},

    }
}

</script>
